import { render, staticRenderFns } from "./AddSaleReturn.vue?vue&type=template&id=2a3522fd&"
import script from "./AddSaleReturn.vue?vue&type=script&lang=js&"
export * from "./AddSaleReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a3522fd')) {
      api.createRecord('2a3522fd', component.options)
    } else {
      api.reload('2a3522fd', component.options)
    }
    module.hot.accept("./AddSaleReturn.vue?vue&type=template&id=2a3522fd&", function () {
      api.rerender('2a3522fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/AddSaleReturn.vue"
export default component.exports